exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-tabs[_v-9db02e98] {\n  margin-bottom: 15px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-9db02e98&file=Tabset.vue&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/Tabset.vue
// module id = 212
// module chunks = 0